// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_oh-0";
export var buttonContainer = "_oh-3";
export var cancelButton = "_oh-4";
export var headerSection = "_oh-6";
export var headerTitle = "_oh-9";
export var messageSideLeft = "_oh-1";
export var messageSideRight = "_oh-2";
export var orderNumberContainer = "_oh-7";
export var orderNumberLabel = "_oh-8";
export var submitButton = "_oh-5";